
import LocomotiveScroll from 'locomotive-scroll';
export class smoothScrollModule {
	constructor() {
		this.smoothScroll()
	}
	private smoothScroll = () => {
		const scroll = new LocomotiveScroll({
			el: document.querySelector('#js-scroll'),
			smooth: true
		});
		
	}
}
